{
    "apartmentInfo": {
        "info": "*all prices include VAT and exclude tourist tax"
    },
    "booking": {
        "bookingForm": {
            "daysSelected": "Days selected",
            "selectMinNDays": "Select min. {{days}} days",
            "maxNPersons": "Max. {{persons}} persons",
            "adultsAge": "Adults (12 years and older)",
            "childrenAge": "Children (6-11 years)",
            "infantsAge": "Infants (up to 5 years)",
            "nights": "Nights",
            "cleaningCosts": "Cleaning costs",
            "totalPrice": "Total price",
            "reserve": "Reserve",
            "bookingsNotPossible": "Bookings are currently not possible. Please try again later.",
            "minimumStay": "Minimum stay",
            "from": "from",
            "to": "to",
            "noPets": "No pets",
            "maxPersonAmountReached": "Maximum person amount reached",
            "minPersonAmountReached": "Minimum person amount reached"
        },
        "bookingFullForm": {
            "createNonBindingRequest": "Create non-binding request",
            "firstName": "First name",
            "lastName": "Last name",
            "street": "Street",
            "houseNumber": "House number",
            "postalCode": "Postal code",
            "place": "Place",
            "phoneNumber": "Phone number",
            "message": "Message",
            "yourMessageToUs": "Your message to us...",
            "agreeTo": "I agree to the",
            "privacyPolicy": "privacy policy",
            "submitRequest": "Submit request",
            "isRequired": "is required",
            "isInvalid": "is invalid",
            "isTooShort": "is too short",
            "isTooLong": "is too long",
            "success": "Your request has been successfully sent.",
            "errorSendingRequest": "Your request could not be sent.",
            "checkInPast": "Check-in cannot be in the past.",
            "checkOutBeforeCheckIn": "Check-out cannot be before check-in.",
            "minimumStay": "At least {{nights}} nights bookable.",
            "maximumStay": "At most {{nights}} nights bookable.",
            "reservationConflict": "A reservation has just been made for this period. Please choose another period.",
            "invalidForm": "Please fill in all required fields correctly. Including the check-in and check-out dates."
        },
        "retry": "Retry"
    },
    "contactApartment": {
        "stillQuestions": "Still questions?",
        "contactApartment": "Contact our apartment",
        "contactForm": {
            "your": "Your",
            "name": "name",
            "firstLastName": "First and last name",
            "writeMessage": "Write us a message..."
        }
    },
    "contactYard": {
        "contactUs": "Contact us",
        "contact": "Contact"
    },
    "footer": {
        "findUsHere": "Here you can find us",
        "book": "Book",
        "imprint": "Imprint",
        "dataProtection": "Data protection",
        "termsAndConditions": "Terms and conditions",
        "austria": "Austria",
        "farm": "Farm",
        "toShop": "To shop"
    },
    "notFound": {
        "siteNotFound": "This site could not be found.",
        "notFound": "Not found",
        "toHome": "To home"
    },
    "priceView": {
        "season": "{{name}}season",
        "showPrices": "Show prices",
        "persons": "Persons",
        "adults": "Adults",
        "children": "Children",
        "cleaningCosts": "Cleaning costs",
        "bookNow": "Book now",
        "priceTableHeader": "Price table for {{seasonName}} season (prices per night)",
        "basePriceInfo": "Up to {{minimumPeople}} people is charged with a base price of {{basePrice}} € and cleaning costs of {{ cleaningCosts }} €.",
        "additionalPersonInfo": "Each additional person +{{cleaningCostsPerPerson}} € cleaning costs.",
        "additionalAdultInfo": "Thereafter, each additional adult +{{adultPrice}} €.",
        "additionalChildInfo": "Each additional child +{{childPrice}} €."
    },
    "product": {
        "addToCart": "Add to cart",
        "selectWeight": "Select weight",
        "yourCartIsEmpty": "Your cart is empty",
        "goToCheckout": "Go to checkout",
        "buyNow": "Buy now",
        "notFound": "Product could not be found.",
        "productNotFound": "The product you are looking for is not available.",
        "inclVat": "incl. VAT",
        "toProduct": "To product",
        "delete": "Delete",
        "noProductsForCategory": "No products available in this category.",
        "maxAmount": "Maximum amount reached",
        "minOne": "Must be at least 1",
        "onlyXLeft": "Only {{amount}} left",
        "outOfStock": "Out of stock",
        "currentlyOutOfStock": "This item is currently out of stock.",
        "available": "Currently available",
        "chooseDeliveryDate": "Choose delivery date",
        "chooseAmount": "Choose amount",
        "chooseWeight": "Choose weight",
        "chooseVariant": "Choose variant",
        "notAvailableAnymore": "Product not available anymore.",
        "removedFromCart": "Product removed from cart.",
        "productUnavailable": "The product {{productName}} is no longer available.",
        "variantUnavailable": "The selected variant {{variant}} of the product {{productName}} is no longer available.",
        "deliveryDateUnavailable": "The selected delivery date {{selectedDeliveryDate}} for the product {{productName}} is no longer available.",
        "maxAmountOfVariant": "You can only add up to {{amount}} items of this variant to your cart.",
        "maxDifferentDeliverydates": "You can only add up to 3 different delivery dates to your cart.",
        "allProducts": "All products: {{category}}"
    },
    "shop": {
        "theBestFromYard": "The best from the yard - ",
        "directlyToYourHome": "Directly to your home",
        "categories": "Categories",
        "allCategories": "All categories",
        "priceRange": "Price range",
        "searchPlaceholder": "Search products...",
        "noProductsFound": "No products found matching your criteria.",
        "sortBy": "Sort by",
        "filterBy": "Filter by",
        "sortByNameAsc": "Name ascending (A-Z)",
        "sortByNameDesc": "Name descending (Z-A)",
        "sortByPriceAsc": "Price ascending (lowest first)",
        "sortByPriceDesc": "Price descending (highest first)",
        "sortByNewest": "Newest first",
        "sortByOldest": "Oldest first",
        "deliveryDate": "Delivery date",
        "ordersSoonAvailable": "Orders are soon available."
    },
    "blog": {
        "readMore": "Read more",
        "nextBlogPost": "Next blog post",
        "close": "Close"
    },
    "newsletter": {
        "error": "Unfortunately something went wrong. Please try again.",
        "subscribeToOurNewsletter": "Receive all meat dates by email",
        "register": "Register",
        "enterEmail": "Enter your email"
    },
    "cookie": {
        "header": "This website uses cookies!",
        "message": "This website uses cookies to ensure you get the best experience on our website.",
        "dismiss": "Got it!",
        "allow": "Allow cookies",
        "deny": "Decline",
        "link": "Learn more",
        "policy": "Cookie Policy"
    },
    "categories": {
        "ourCategories": "Unsere Kategorien"
    }
}